module.exports = __webpack_public_path__ + "img/ryzs14.1999a16c.jpg";